<template>
  <div
    :class="['connect-channel-card', `connect-channel-card--${channel}`, {'connect-channel-card--connected': isConnected}, {'connect-channel-card--connected-fb': isConnected && channel === 'fb'}]">
    <template v-if="!isConnected || (channel === 'fb' && isConnected)">
      <div :class="{'connect-channel-card__img': true, 'google': channel === 'google', 'fb': channel === 'fb', 'connect-channel-card__img--disabled': !isPaidUser && !isNew}">
        <div>
          <img :src="`/static/img/${channelImage['notConnected'][channel]}.png`" :srcset="`/static/img/${channelImage['notConnected'][channel]}@2x.png 2x, /static/img/${channelImage['notConnected'][channel]}@3x.png 3x`" :alt="channel"
               class="connect-channel-card__gmb-logo"/>

          <div class="connect-channel-card__upgrade-popup" @click="redirectToRenewOrUpgrade()" v-if="!isPaidUser && !isNew">
            <img src="/static/img/lock-icon.svg"/>
            <div class="connect-channel-card__upgrade-popup-msg">Upgrade to gain instant access</div>
          </div>
        </div>
        <span class="connect-channel-card__new" v-if="isNew">NEW</span>
      </div>
      <div class="connect-channel-card__text-row">
        <div class="connect-channel-card__text">
          <strong v-if="!isNew && channel !== 'fb'">Google My Business</strong>
          <strong v-else>Facebook</strong>
        </div>
        <a v-if="channel === 'fb' && isConnected" class="button connect-channel-card__connect-btn"
           :class="{'connect-channel-card__disabled-connect': !isPaidUser}"
           :data-track="`Connect ${channel} Account`"
           @click="removeClicked">REMOVE</a>
        <a v-else class="button connect-channel-card__connect-btn"
           :class="{'connect-channel-card__disabled-connect': !isPaidUser}"
           :data-track="`Connect ${channel} Account`"
           @click="connectClicked">CONNECT</a>
      </div>
    </template>
    <template v-else>
      <div class="has-text-centered margin-bottom-12">
        <img src="/static/img/review-invites/path-6664.svg" class="valign-super">
        &nbsp;
        <img :src="`/static/img/${channelImage['connected'][channel]}`" :alt="channel"
             class="connect-channel-card__connected-logo"/>
      </div>
      <p class="margin-bottom-2 ellipses">
        <strong>Google Account:</strong>
        {{ accountDetails.accountName }}
      </p>
      <p class="margin-bottom-2">
        <strong>Business:</strong>
        {{ accountDetails.bizName }}
      </p>
      <p>
        <strong>Location:</strong>
        {{ accountDetails.location }}
      </p>
      <div class="connect-channel-card__btn-row">
        <button
          class="button solid-btn is-borderless"
          :data-track="`Connect ${channel} Account`"
          @click="editClicked"
        >EDIT
        </button>
        <button
          class="button hollow-btn"
          :data-track="`Remove ${channel} Account`"
          @click="removeClicked"
        >REMOVE ACCOUNT
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import {misc} from '@/mixins'

export default {
  name: 'ConnectChannelCard',
  props: {
    channel: {
      type: String,
      default: 'google'
    },
    isNew: {
      type: Boolean,
      default: false
    },
    connectBtnAction: {
      type: Function
    },

    accountDetails: {
      type: Object,
      default () {
        return {}
      }
    },
    editBtnAction: {
      type: Function
    },
    removeBtnAction: {
      type: Function
    }
  },
  data () {
    return {
      channelImage: {
        'connected': {
          'google': 'review-invites/mask-group-265@3x.png',
          'fb': 'review-invites/mask-group-265@3x.png'
        },
        'notConnected': {
          'google': 'reviews/google_channel_new',
          'fb': 'reviews/facebook_channel'
        }
      }
    }
  },
  mixins: [misc],
  methods: {
    connectClicked () {
      // console.log(this.isNew, this.connectBtnAction, this.isPaidUser)
      // if (!this.isNew && this.connectBtnAction) {
      if (this.connectBtnAction) {
        if (!this.isPaidUser) {
          this.redirectToRenewOrUpgrade()
          return false
        }

        var currentUrl = this.$router.currentRoute
        if (currentUrl.path.indexOf('onsite-widgets/details') > -1) {
          window.localStorage.setItem('widget_redirect_url', currentUrl.path)
        } else {
          window.localStorage.removeItem('widget_redirect_url')
        }
        this.connectBtnAction()
      }
    },
    editClicked () {
      if (this.editBtnAction) {
        this.editBtnAction()
      }
    },
    removeClicked () {
      if (this.removeBtnAction) {
        this.removeBtnAction()
      }
    }
  },
  computed: {
    isConnected () {
      if (this.channel === 'gmb' || this.channel === 'google') {
        return ('accountName' in this.accountDetails) && this.accountDetails.accountName
      }
      return ('pageID' in this.accountDetails) && this.accountDetails.pageID
    }
  }
}
</script>

<style scoped>
.connect-channel-card {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16);
  border: solid 1px rgba(216, 216, 216, 0.32);
  width: 278px;
  margin-top: 10px;
  display: inline-block;
}

.connect-channel-card__img {
  background: url("/static/img/review-invites/mask-group-267.png");
  width: 278px;
  height: 140px;
  position: relative;
}

.connect-channel-card__img.google > div {
  padding-top: 38px;
  width: 124px;
  margin: 0 auto;
}

.connect-channel-card__img.fb > div {
  padding-top: 38px;
  width: 146px;
  margin: 0 auto;
}

.connect-channel-card--fb .connect-channel-card__img > div {
  padding-top: 44px;
}

.connect-channel-card--fb .connect-channel-card__gmb-logo {
  max-width: unset;
}

.connect-channel-card__text {
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  margin: 17px 0;
}

.connect-channel-card__new {
  border-radius: 2px;
  background-color: #17be86;
  font-size: 10px;
  color: #fff;
  position: absolute;
  top: 14px;
  left: -1px;
  padding: 4px 13px 3px 15px;

}

.connect-channel-card__text-row {
  text-align: center;
}

.connect-channel-card__connect-btn {
  height: 35px;
  font-size: 12px;
  line-height: 17px;
  color: #fff;
  background: #1261a0;
  border-radius: 2px;
  width: 130px;
  text-align: center;
  margin: 0 0 25px;
}

.connect-channel-card__disabled-connect {
  opacity: 0.7;
  background: #cdcbcb;
}

.connect-channel-card__img--disabled {
  position: relative;
  text-align: center;
}

.connect-channel-card__img--disabled:hover .connect-channel-card__gmb-logo {
  opacity: 0.25;
}

.connect-channel-card__upgrade-popup {
  position: absolute;
  top: 0px;
  left: 0px;
  background: rgba(0, 0, 0, 0.51);
  height: 100%;
  width: 100%;
  z-index: 999;
  opacity: 1;
  display: none;
  color: #ffffff;
  cursor: pointer;
}

.connect-channel-card__upgrade-popup img {
  position: relative;
  top: -15px;
  height: 27px;
}

.connect-channel-card__upgrade-popup .connect-channel-card__upgrade-popup-msg {
  font-size: 14px;
}

.connect-channel-card__img--disabled:hover .connect-channel-card__upgrade-popup {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.connect-channel-card--connected {
  padding: 15px 5px 24px;
}

.connect-channel-card--connected-fb {
  padding: 0!important;
}

.connect-channel-card__connected-logo {
  max-width: 30px;
}

.solid-btn {
  font-size: 12px;
  padding: 9px 52px;
  margin-right: 1px;
}

.hollow-btn {
  font-size: 12px;
  padding: 10px;
}

.connect-channel-card__btn-row {
  margin-top: 76px;
}
</style>



// WEBPACK FOOTER //
// src/components/ConnectChannelCard.vue